(function($) {
	$.fn.addToBasket = function() {
		$(this).on('click', function() {
			// $(this).rendre incliquable lorsqu'une requête est en cours, remettre dans le success ou error
			var data = productsToBasket();
			var $that = $(this);

			$that.attr("disabled", true);

			if (data.length > 0) {
				$.ajax({
					type: "POST",
					url: '/api/basket/add-product/',
					headers: {
	                    'X-CSRFToken': csrftoken
	              	},
					data: JSON.stringify(data),
					contentType: "application/json",
					success: function(res) {
						$alert = $('.js-basket-alert');
						$basket = $('#basket_product_number');
						$alert.fadeIn().delay(2000).fadeOut();
						$basket.data('number', parseInt(res[0].basket_num_lines));
						$basket.text($basket.data('number'));
						$that.attr("disabled", false);

						var items = [];
						var totalValue = 0;
						res.forEach(function(product) {
							items.push({
								item_name: product.product_title,
								item_id: product.product_code,
								item_category: product.product_category,
								price: product.product_unit_price,
								quantity: product.quantity
							});
							totalValue += product.product_unit_price * product.quantity;
						});
						window.dataLayer = window.dataLayer || [];
						window.dataLayer.push({
							event: 'add_to_cart',
							value: totalValue,
							ecommerce: {
								currency: res[0].price_currency,
								items: items
							}
						});
					},
					error: function(xhr, status, error) {
						_reason = JSON.parse(xhr.responseText).reason;
						setError(_reason, $that);

					}
				});
			} else {
				setError('Quantité nulle', $that);
			}
		});
	}
}( jQuery ));

(function($) {
	$.fn.addLogoPriceToBasket = function() {
		$(this).on('click', function() {
			hasItems = productsToBasket();

			if (hasItems.length > 0) {
				var data = [{
					"url": "/api/products/" + $('#logoToBasket').attr('data-product-id') + "/",
					"quantity": $('#logoToBasket').val(),
					"attached_to__product_id": "-1",
					"is_customized": false,
					"logo": $('#logo_id').val()
				}];
				if ($('#logoToBasket').attr('data-product-id')) {
					$.ajax({
						type: "POST",
						url: '/api/basket/add-product/',
						headers: {
		                      'X-CSRFToken': csrftoken
		              	},
						data: JSON.stringify(data),
						contentType: "application/json",
						success: function(res) {
							$('#logoToBasket').val(0);
							// $('.js-basket-alert').fadeIn().delay(2000).fadeOut();
						},
						error: function(err) {
							// $('.js-basket-error').fadeIn().delay(2000).fadeOut();
						}
					});
				}
			}
		});
	}
}( jQuery ));

(function($) {
	$.fn.addCustomizationPriceToBasket = function() {
		$(this).on('click', function() {
			hasItems = productsToBasket();

			if (hasItems.length > 0) {
				var data = [{
					"url": "/api/products/" + $('#customizationToBasket').attr('data-product-id') + "/",
					"quantity": $('#customizationToBasket').val(),
					"attached_to__product_id": "-1",
					"is_customized": false,
					"logo": $('#logo_id').val()
				}];
				if ($('#customizationToBasket').attr('data-product-id')) {
					$.ajax({
						type: "POST",
						url: '/api/basket/add-product/',
						headers: {
		                      'X-CSRFToken': csrftoken
		              	},
						data: JSON.stringify(data),
						contentType: "application/json",
						success: function(res) {
							console.log(res);
							$('#customizationToBasket').val(0);
							// $('.js-basket-alert').fadeIn().delay(2000).fadeOut();
						},
						error: function(err) {
							console.log(err);
							// $('.js-basket-error').fadeIn().delay(2000).fadeOut();
						}
					});
				}
			}
		});
	}
}( jQuery ));

function productsToBasket() {
	var data = [];
	$('.js-quantity').each(function(){
		$this = $(this);
		// console.log($this);
		$checkbox = $this.parents('.js-checkbox-parent').find('.js-checkbox');
		if ($this.val() > 0 && $checkbox.is(':checked')) {
			var correspondingProductId = $this.parents('.js-checkbox-parent').attr('data-id');
			var correspondingOptionId = $this.parents('.js-checkbox-parent').attr('option-id');
			if (correspondingOptionId){
				correspondingOptionId=parseInt(correspondingOptionId)
			}
			var attached_to = $this.hasClass("js-sub-quantity") ? correspondingProductId : "-1";
			if ($('#js-configurator-products').length) {
				data.push({
					"url": "/api/products/" + $this.attr('data-id') + "/",
					"quantity": $this.val(),
					"attached_to__product_id": attached_to,
					"is_customized": true,
					"impression_option":correspondingOptionId,
					"logo": $('#logo_id').val(),
					"color": $('#logo_color').val(),
					"position": $('#logo_position').val()
				});
			} else {
				data.push({
					"url": "/api/products/" + $this.attr('data-id') + "/",
					"quantity": $this.val(),
					"impression_option":correspondingOptionId,
					"attached_to__product_id": attached_to,
					"is_customized": false
				});
			}
		}
	});
	return data;
}

function getBasketItemsNumber() {
	$.ajax({
		type: "GET",
		url: "/api/basket/",
		headers: {
            'X-CSRFToken': csrftoken
      	},
      	success: function(res){
      		console.log(res);
      	},
      	error: function(err){
      		console.log(err);
      	}
	});
}


// TOGGLE ALERT
function setError(message, el) {
	var $error = $('.js-basket-error');
	if (el) {
		el.prop("disabled", true);
	}
	$('.js-basket-error').text(message);
	$error.fadeIn().delay(2000).fadeOut(300, function() {
		if (el) {
			el.prop("disabled", false);
		}
	});
}

$(function(){
	if ($('#add-to-basket').length) {
		// $('#add-to-basket').on('click', function(){
		// 	productsToBasket();
		// });
		$('#add-to-basket').addToBasket();
	}
	if ($('#logoToBasket').length) {
		$('#add-to-basket').addLogoPriceToBasket();
	}
	if ($('#customizationToBasket').length) {
		$('#add-to-basket').addCustomizationPriceToBasket();
	}
});
